import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdListHeader = () => import('@/components/DdListHeader')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdTextBox = () => import('@/components/DdTextBox')
const DdYearMonthBoxWithSelector = () => import('@/components/DdYearMonthBoxWithSelector')

export default {
  name: 'ShiharaiList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdNumericBox,
    DdListHeader,
    DdRadioButton,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdYearMonthBoxWithSelector
  },
  data: () => ({
    selected: [{}],
    itemsPerPage: 25,
    page: 1,
    isCsvDownloader: false,
    isPdfDownloader: false,

    balkOperation: '一括操作',
    conditions: {
      shiharaisho: '',
      torihikisakiCd: '',
      shiharaiNo: '',
      shiharaiYm: '',
      shimeDay: '',
      shiborikomiStartDay: '',
      shiborikomiEndDay: '',
      shiharaishoKarihakko: '',
      eigyoshoCd: '',
      shiharaiZeroFlg: false,
      shanaiTantoshaCd: '',
      targetShiharaisho: null,
      targetKarihakko: null
    },
    conditionDetails: [
      { key: 'shiharaiYm', name: '締め年月', value: 'shiharaiYm', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'shimeDay', name: '締日', value: 'shimeDay', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'eigyoshoCd', name: '営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'torihikisakiCd', name: '取引先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'shiharaiNo', name: '明細番号', value: 'shiharaiNo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'targetShiharaisho', name: '傭車明細書出力状況', value: 'targetShiharaisho', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'targetKarihakko', name: '仮発行', value: 'targetKarihakko', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'shiharaiZeroFlg', name: '当月発注無しも表示する', value: null, type: 'checkbox', delete: true, showValue: false, convertValue: false }
    ],
    headersShiharaisakiList: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersJininList: header.mstJininHeaders,
    // 表示制御
    dispShiharaisho: '',
    dispShiharaiIchiranHyo: '',
    dispShiharaiIchiranCsv: '',
    modeKengen: 0,
    CancelButtonDisp: false,
    PrintButtonDisp: false,
    lastShimeYmd: ''
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 傭車明細書
    'conditions.shiharaisho': function (n) {
      this.conditions.targetShiharaisho = this.conditions.shiharaisho === '01' ? '未出力' : this.conditions.shiharaisho === '02' ? '出力済み（取消除く）' : this.conditions.shiharaisho === '03' ? '出力済（取消含む）' : '全て'
    },
    // 仮発行
    'conditions.seikyushoKarihakko': function (n) {
      this.conditions.targetKarihakko = this.conditions.seikyushoKarihakko === '01' ? '含む' : '含まない'
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shiharaisakiList: 'DDMasters/vwCMstTorihikisakiGetShiharaisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyosho: 'users/eigyoshoCd',
      JininList: 'DDMasters/vwCMstEigyoshoJininList',
      messageList: 'DDMasters/msysMessage',
      systemConfigList: 'DDMasters/msysSystemConfig',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredShiharaisakiList () {
      // 支払先限定
      const target = filter.dateFormatter(new Date())
      return this.shiharaisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.JininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        if (elem.jininNmSei) { elem.hakkoshaNm = elem.jininNmSei + elem.jininNmMei ? elem.jininNmMei : '' }
        if (elem.torihikisakiCd) { elem.torihikisakiCdNm = elem.torihikisakiCd + ':' + elem.torihikisakiNm }
        elem.konkaiShiharaiKingaku = filter.numericFormatter(elem.konkaiShiharaiKingaku) + '円'
        elem.kihonUnchiGokei = filter.numericFormatter(elem.kihonUnchiGokei) + '円'
        elem.warimashiKingakuGokei = filter.numericFormatter(elem.warimashiKingakuGokei) + '円'
        elem.kazeiKingakuGokei = filter.numericFormatter(elem.kazeiKingakuGokei) + '円'
        elem.konkaiTax = filter.numericFormatter(elem.konkaiTax) + '円'
        elem.hiwayPriceGokei = filter.numericFormatter(elem.hiwayPriceGokei) + '円'
        elem.uchizeiKingakuGokei = filter.numericFormatter(elem.uchizeiKingakuGokei) + '円'
        elem.hikazeiKingakuGokei = filter.numericFormatter(elem.hikazeiKingakuGokei) + '円'
        if (elem.shiharaishoHakkoYmd) { elem.shiharaishoHakkoYmd = filter.dateYmdHmsFormatter(elem.shiharaishoHakkoYmd) }
        if (elem.shiharaiYmd) { elem.shiharaiYmd = filter.dateFormatter(elem.shiharaiYmd) }
        if (elem.shukkinYoteiYmd) { elem.shukkinYoteiYmd = filter.dateFormatter(elem.shukkinYoteiYmd) }
        if (elem.shiborikomiStartYmd || elem.shiborikomiEndYmd) { elem.shiborikomiYmd = filter.dateFormatter(elem.shiborikomiStartYmd) + ' ~ ' + filter.dateFormatter(elem.shiborikomiEndYmd) }
        if (elem.torikeshiJininNmSei) { elem.torikeshishaNm = elem.torikeshiJininNmSei + (elem.torikeshiJininNmMei ? elem.torikeshiJininNmMei : '') }
        if (elem.torikeshiYmd) { elem.torikeshiYmd = filter.dateYmdHmsFormatter(elem.torikeshiYmd) }

        return elem
      })
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isSelected () {
      if (this.selected.length === 0 || this.selected.length > 10) { return true }
      return false
    },
    isCancelButtonDisabled  () {
      if (this.selected.length === 0) { return true }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
    this.selected = []
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetshiharaisaki', 'msttorihikisaki', 'msteigyosho', 'vwcmsteigyoshojininlist', 'msyssystemconfig'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: '明細', value: 'actions', align: 'center', sortable: false },
              { text: '明細書', value: 'shiharaisho' },
              { text: '仮発行', value: 'shiharaishoKarihakkoFlg', align: 'center' },
              { text: '明細番号', value: 'shiharaiNo' },
              { text: '取引先コード/名称', value: 'torihikisakiCdNm' },
              { text: '当月傭車額', value: 'konkaiShiharaiKingaku' },
              { text: '(運賃)', value: 'kihonUnchiGokei' },
              { text: '(割増)', value: 'warimashiKingakuGokei' },
              { text: '(その他課税)', value: 'kazeiKingakuGokei' },
              { text: '(消費税)', value: 'konkaiTax' },
              { text: '(高速代)', value: 'hiwayPriceGokei' },
              { text: '(その他内税)', value: 'uchizeiKingakuGokei' },
              { text: '(その他非課税)', value: 'hikazeiKingakuGokei' },
              { text: '発行者', value: 'hakkoshaNm' },
              { text: '発行日', value: 'shiharaishoHakkoYmd' },
              { text: '取消者', value: 'torikeshishaNm' },
              { text: '取消日', value: 'torikeshiYmd' },
              { text: '締日', value: 'shimeDay' },
              { text: '支払予定日', value: 'shiharaiYmd' },
              { text: '出金予定日', value: 'shukkinYoteiYmd' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '固有コード', value: 'userCustomCd1' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            var today = new Date()
            self.conditions = {
              shiharaisho: '01',
              torihikisakiCd: '',
              shiharaiNo: '',
              shiharaiYm: ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2),
              shimeDay: '',
              shiborikomiStartDay: '',
              shiborikomiEndDay: '',
              shiharaishoKarihakko: '01',
              eigyoshoCd: self.userEigyoshoCd,
              shiharaiZeroFlg: false,
              shanaiTantoshaCd: '',
              targetShiharaisho: null,
              targetKarihakko: null
            }
            self.selected = []
            self.page = 1
            self.CancelButtonDisp = false
            self.PrintButtonDisp = false
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            if (self.modeKengen !== 0) {
              this.PrintButtonDisp = true
            }

            if (self.modeKengen === 2) {
              this.CancelButtonDisp = true
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      this.getShimeJisseki()
    },
    settingShiharaiYm: function (p) {
      this.conditions.shiharaiYm = p
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      if ([undefined, null, ''].includes(self.conditions.shiharaiZeroFlg)) {
        self.conditions.shiharaiZeroFlg = false
      }
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/d2payd0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            shiharaisho: self.conditions.shiharaisho,
            shiharaishoKarihakko: self.conditions.shiharaishoKarihakko,
            shiharaiZeroFlg: self.conditions.shiharaiZeroFlg
          }
        }
      }
      this.search(opt)
      this.selected = []
      this.getShimeJisseki()
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            var today = new Date()
            self.conditions = {
              shiharaisho: '01',
              torihikisakiCd: '',
              shiharaiNo: '',
              shiharaiYm: ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2),
              shimeDay: '',
              shiborikomiStartDay: '',
              shiborikomiEndDay: '',
              shiharaiKarihakko: '01',
              eigyoshoCd: self.userEigyoshoCd,
              shiharaiZeroFlg: false,
              shanaiTantoshaCd: '',
              targetShiharaisho: null,
              targetKarihakko: null
            }
            self.selected = []
            self.page = 1
            self.rows = []
            self.CancelButtonDisp = false
            self.PrintButtonDisp = false
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      if (!this.getSystemConfigInfo()) { return }
      this.Effects.loadStart()
      var param = {
        shiharaiId: f.item.id,
        shiharaiNo: f.item.shiharaiNo,
        shiharaisho: f.item.shiharaisho,
        shiharaiYmd: f.item.shiharaiYmd,
        shimeYm: f.item.shiharaiYm,
        shimeDay: f.item.shimeDay,
        shiharaiShimeDate: f.item.shiharaiShimeDate,
        shiborikomiStartYmd: f.item.shiborikomiStartYmd,
        shiborikomiEndYmd: f.item.shiborikomiEndYmd,
        shiharaisakiCd: f.item.torihikisakiCd,
        shiharaisakiNm: f.item.torihikisakiNm,
        eigyoshoCd: f.item.eigyoshoCd,
        eigyoshoNm: f.item.eigyoshoNm,
        shiharaishoKarihakkoFlg: f.item.shiharaishoKarihakkoFlg
      }
      this.transition(0, param)
    },
    onRowShowDetailButtonClick: function (e) {
      console.log('onRowShowDetailButtonClick', e)
      if (!this.getSystemConfigInfo()) { return }
      this.Effects.loadStart()
      var param = {
        shiharaiId: e.id,
        shiharaiNo: e.shiharaiNo,
        shiharaisho: e.shiharaisho,
        shiharaiYmd: e.shiharaiYmd,
        shimeYm: e.shiharaiYm,
        shimeDay: e.shimeDay,
        shiharaiShimeDate: e.shiharaiShimeDate,
        shiborikomiStartYmd: e.shiborikomiStartYmd,
        shiborikomiEndYmd: e.shiborikomiEndYmd,
        shiharaisakiCd: e.torihikisakiCd,
        shiharaisakiNm: e.torihikisakiNm,
        eigyoshoCd: e.eigyoshoCd,
        eigyoshoNm: e.eigyoshoNm,
        shiharaishoKarihakkoFlg: e.shiharaishoKarihakkoFlg
      }
      this.transition(0, param)
    },
    onRowEditDetailButtonClick: function (e) {
      console.log('onRowShowDetailButtonClick', e)
      if (!this.getSystemConfigInfo()) { return }
      this.Effects.loadStart()
      var param = {
        shiharaiId: e.id,
        shiharaiNo: e.shiharaiNo,
        shiharaisho: e.shiharaisho,
        shiharaiYmd: e.shiharaiYmd,
        shimeYm: e.shiharaiYm,
        shimeDay: e.shimeDay,
        shiharaiShimeDate: e.shiharaiShimeDate,
        shiborikomiStartYmd: e.shiborikomiStartYmd,
        shiborikomiEndYmd: e.shiborikomiEndYmd,
        shiharaisakiCd: e.torihikisakiCd,
        shiharaisakiNm: e.torihikisakiNm,
        eigyoshoCd: e.eigyoshoCd,
        eigyoshoNm: e.eigyoshoNm,
        shiharaishoKarihakkoFlg: e.shiharaishoKarihakkoFlg
      }
      this.transition(0, param)
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.clearSummaryMessage()
      this.HttpClient
        .post('/api/v1/d2payd0010/csvdownload', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = `支払一覧_${this.getTimeStamp()}.csv`
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      this.Effects.loadStart()
      this.clearSummaryMessage()
      this.HttpClient
        .requestFileByPost('/api/v1/d2payd0010/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = `支払一覧_${this.getTimeStamp()}.pdf`
          elem.click()
          this.setInvalidSummaryMessage('COMI0007')
          this.Effects.loadComplete()
        })
    },
    onCancelButtonClick: function (e) {
      this.clearSummaryMessage()

      var checkResult = this.checkSelected('出力済')
      if (checkResult !== '') {
        this.setInvalidSummaryMessage('PAYE0003')
        return false
      }
      // 仮発行だった場合、エラー
      for (const row of this.selected) {
        if (row.shiharaishoKarihakkoFlg !== false) {
          this.setInvalidSummaryMessage('PAYE0004')
          return false
        }
      }
      // 月次確定処理を行ったデータだった場合、エラー
      for (const row of this.selected) {
        if (row.trKessanGetsujiKanriId !== null) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        this.selected = this.removeFilterTable(this.selected)
        this.HttpClient.post('/api/v1/d2payd0010/shiharaicancel', this.selected)
          .then((data) => {
            if (data.isValid) {
              this.loadFromCache()
                .then((c) => {
                  this.conditions = c.value.conditions || {}
                  this.onSearchButtonClick()
                })
                .then(() => {
                  this.setInvalidSummaryMessage('COMI0005')
                  this.Effects.loadComplete()
                })
            } else {
              this.Effects.loadComplete()
              this.setInvalidSummaryMessage(data.summaryMessage)
            }
          })
      })
    },
    onPrintButtonClick: function (karihakkoFlg) {
      var kariFlg = karihakkoFlg
      console.log(this.selected)
      var checkResult = this.checkSelected('未出力')
      if (checkResult !== '') {
        if (kariFlg === false) { this.setInvalidSummaryMessage('PAYE0001') }
        if (kariFlg === true) { this.setInvalidSummaryMessage('PAYE0002') }
        return false
      }
      if (this.lastShimeYmd !== '') {
        if (this.checkShimeJisseki() !== '') {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      this.Effects.loadStart()
      var path = null
      this.removeFilterTable(this.selected)
      let cnt = 0
      this.dispShiharaisho = `支払書_${this.getTimeStamp()}.pdf`
      this.selected.forEach(p => {
        if (!p.shiharaiTsuchishoLayoutKbn && !p.shiharaiMeisaishoLayoutKbn) {
          if (kariFlg === false) {
            path = '/api/v1/d2payd0010/createshiharaidata'
          } else if (kariFlg === true) {
            path = '/api/v1/d2payd0010/createshiharaidatakari'
          }
          return this.HttpClient.post(path, p)
            .then((data) => {
              cnt++
              if (cnt === this.selected.length) {
                this.loadFromCache()
                  .then((c) => {
                    this.conditions = c.value.conditions || {}
                    this.onSearchButtonClick()
                  })
                  .then(() => {
                    if (data.summaryMessage) {
                      data.isValid ? this.setInvalidSummaryMessage('PAYE0005') : this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                    } else {
                      this.setInvalidSummaryMessage('PAYE0005')
                    }
                    this.Effects.loadComplete()
                  })
              }
            })
        } else {
          if (kariFlg === false) {
            path = '/api/v1/d2payd0010/printpayment'
          } else if (kariFlg === true) {
            path = '/api/v1/d2payd0010/printpaymentkari'
          }
          return this.HttpClient
            .requestFileByPost(path, p).then(data => {
              // aタグにファイル仕込んでClickする処理
              const blob = new Blob([data], { type: 'application/pdf' })
              const elem = document.getElementById('shiharaishoDownload')
              elem.href = window.URL.createObjectURL(blob)
              elem.click()

              cnt++
              if (cnt === this.selected.length) {
                this.loadFromCache()
                  .then((c) => {
                    this.conditions = c.value.conditions || {}
                    this.onSearchButtonClick()
                  })
                  .then(() => {
                    this.setInvalidSummaryMessage('COMI0007')
                    this.Effects.loadComplete()
                  })
              }
            })
        }
      })
    },
    onPrintAgainButtonClick: function (e) {
      var checkResult = this.checkSelected('出力済')
      if (checkResult !== '') {
        this.setInvalidSummaryMessage('PAYE0004')
        return false
      }
      this.Effects.loadStart()
      this.removeFilterTable(this.selected)
      let cnt = 0
      this.dispShiharaisho = `支払書_${this.getTimeStamp()}.pdf`
      this.selected.forEach(p => {
        if (!p.shiharaiTsuchishoLayoutKbn && !p.shiharaiMeisaishoLayoutKbn) {
          cnt++
          if (cnt === this.selected.length) {
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('PAYE0005')
          }
        } else {
          return this.HttpClient
            .requestFileByPost('/api/v1/d2payd0010/printpaymentagain', p).then(data => {
            // aタグにファイル仕込んでClickする処理
              const blob = new Blob([data], { type: 'application/pdf' })
              const elem = document.getElementById('shiharaishoDownload')
              elem.href = window.URL.createObjectURL(blob)
              elem.click()
              cnt++
              if (cnt === this.selected.length) {
                // 完了処理
                this.Effects.loadComplete()
                this.setInvalidSummaryMessage('COMI0007')
              }
            })
        }
      })
    },
    searchValidate: function () {
      var checkRes1 = this.shimeDayCheck()
      var checkRes2 = this.shiborikomiDateCheck()
      if (!checkRes1 || !checkRes2) { return false }
      if (this.conditions.shiharaiYm) {
        if (this.conditions.shiharaiYm.length !== 7) {
          this.$refs.shiharaiYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0012'))
          return false
        }
      }
      return true
    },
    shimeDayCheck: function () {
      if (this.conditions.shimeDay === '') { return true }
      var shimebi = parseInt(this.conditions.shimeDay)
      if ((shimebi >= 32 && shimebi <= 98) || shimebi === 0) {
        this.$refs.shimeDay[this.Ctrls.SET_INVALID_METHOD](message.get('BILV0001'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      return true
    },
    shiborikomiDateCheck: function () {
      if (this.conditions.shiborikomiStartDay === '' && this.conditions.shiborikomiEndDay === '') {
        return true
      } else if ((this.conditions.shiborikomiStartDay !== null || this.conditions.shiborikomiStartDay !== '' || this.conditions.shiborikomiStartDay !== undefined) && (this.conditions.shiborikomiEndDay !== null || this.conditions.shiborikomiEndDay !== '' || this.conditions.shiborikomiEndDay !== undefined)) {
        if (!this.conditions.shiharaiYm) {
          this.$refs.shiharaiYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', ['絞込日', '支払年月']))
          this.setInvalidSummaryMessage('COME0012')
          return false
        }
        if (!this.checkDate(this.conditions.shiharaiYm, this.conditions.shiborikomiStartDay)) {
          this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(From)'))
          this.setInvalidSummaryMessage('COME0011')
          return false
        }
        if (!this.checkDate(this.conditions.shiharaiYm, this.conditions.shiborikomiEndDay)) {
          this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(To)'))
          this.setInvalidSummaryMessage('COME0011')
          return false
        }
        if (parseInt(this.conditions.shiborikomiStartDay, 10) > parseInt(this.conditions.shiborikomiEndDay, 10)) {
          this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(From)', '絞込日(To)'))
          this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '絞込日(From)', '絞込日(To)'))
          this.setInvalidSummaryMessage('COME0012')
          return false
        }
      } else if (this.conditions.shiborikomiStartDay === '') {
        this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', '絞込日(From)', '絞込日(To)'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      } else if (this.conditions.shiborikomiEndDay === '') {
        this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', '絞込日(From)', '絞込日(To)'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      return true
    },
    checkSelected (type) {
      for (const row of this.selected) {
        if (row.shiharaisho !== type) { return row.shiharaisho }
      }
      return ''
    },
    checkShimeJisseki () {
      for (const row of this.selected) {
        if (row.shiharaiYmd <= this.lastShimeYmd) { return row.shiharaiYmd }
      }
      return ''
    },
    setShiharaishoColor (shiharaisho) {
      if (shiharaisho === '取消済') return 'red--text'
      else if (shiharaisho === '出力済') return 'blue--text'
    },
    removeFilterTable (data) {
      // 金額項目の','と'円'を削除する
      return data.map((elem) => {
        elem.konkaiShiharaiKingaku = this.removeFilterKingaku(elem.konkaiShiharaiKingaku)
        elem.kihonUnchiGokei = this.removeFilterKingaku(elem.kihonUnchiGokei)
        elem.warimashiKingakuGokei = this.removeFilterKingaku(elem.warimashiKingakuGokei)
        elem.kazeiKingakuGokei = this.removeFilterKingaku(elem.kazeiKingakuGokei)
        elem.konkaiTax = this.removeFilterKingaku(elem.konkaiTax)
        elem.hiwayPriceGokei = this.removeFilterKingaku(elem.hiwayPriceGokei)
        elem.uchizeiKingakuGokei = this.removeFilterKingaku(elem.uchizeiKingakuGokei)
        elem.hikazeiKingakuGokei = this.removeFilterKingaku(elem.hikazeiKingakuGokei)

        return elem
      })
    },
    removeFilterKingaku (dispKingaku) {
      var target = dispKingaku.replace('円', '')
      if (target.length > 3) {
        target = target.replace(/,/g, '')
      }
      return target
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },
    getSystemConfigInfo: function () {
      var systemConfig = this.systemConfigList.filter((t) => {
        return t.configName === 'shiharai_meisai_shiyo_flg'
      })
      if (systemConfig.length > 0 && systemConfig[0].configValue1 === 'NO') {
        return false
      } else {
        return true
      }
    },
    checkDate: function (shiharaiYm, day) {
      var y = ('0000' + shiharaiYm.split('/')[0]).slice(-4)
      var targetMonth = ('00' + shiharaiYm.split('/')[1]).slice(-2)
      var m = targetMonth - 1
      var d = ('00' + day).slice(-2)
      var date = new Date(y, m, d)
      var resultYear = ('0000' + date.getFullYear()).slice(-4)
      var resultMonth = ('00' + (date.getMonth() + 1)).slice(-2)
      var resultDay = ('00' + date.getDate()).slice(-2)

      console.log(resultYear, resultMonth, resultDay)
      if (resultYear !== y || resultMonth !== targetMonth || resultDay !== d) {
        return false
      }
      return true
    },
    getShimeJisseki: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/TrKessanGetsujiKanri/GetAll')
          .then((data) => {
            if (data.payload) {
              var shiharaiShimeList = data.payload.map((elem) => {
                elem.taishoShimeYmd = new Date(elem.taishoYm + '/' + elem.taishoShimeDay)
                return elem
              }).filter(function (elem) {
                return elem.taishoGyomuCd === '02' && elem.delFlg === false
              })
              this.lastShimeYmd = shiharaiShimeList.length !== 0 ? filter.dateFormatter(shiharaiShimeList[shiharaiShimeList.length - 1].taishoShimeYmd) : ''
            }
            resolve()
          })
      })
    },
    onApplyButtonClick: function () {
      if (this.balkOperation === '取消') {
        this.onCancelButtonClick()
      } else if (this.balkOperation === '支払書仮発行') {
        this.onPrintButtonClick(true)
      } else if (this.balkOperation === '支払書再発行') {
        this.onPrintAgainButtonClick()
      } else if (this.balkOperation === '支払書発行') {
        this.onPrintButtonClick(false)
      }
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
